import { appState, dispatchStateEvent } from '../../store/appState.js';
import { fetchWallets } from '../../api/wallets.js';
import { fetchCategories, fetchTags } from '../../api/categories.js';

let currentPickerTarget = ''; 
let tempSelection = { id: null, name: '' }; 
let currentPickerData = []; // Lưu trữ data hiện tại để check trùng lặp

export function initItemPickerModal() {
    const itemPickerModal = document.getElementById('item-picker-modal');
    const pickerList = document.getElementById('picker-list');
    const pickerInputNew = document.getElementById('picker-input-new');
    
    if(!itemPickerModal) return;

    // Hàm Render các thẻ Tag nhỏ gọn
    function renderPickerList(data) {
        currentPickerData = data; 
        pickerList.innerHTML = '';
        
        if (data.length === 0) {
            pickerList.innerHTML = '<p class="text-center w-full text-gray-500 mt-2 text-sm">No items yet.</p>';
            return;
        }

        data.forEach(item => {
            const btn = document.createElement('button');
            btn.className = 'px-3 py-1.5 rounded-full border border-gray-600 bg-darkbg text-sm text-gray-300 hover:text-white transition picker-item-btn';
            btn.innerHTML = item.name;
            btn.id = 'picker-btn-' + item.id; 
            
            if (tempSelection.id === item.id) {
                btn.classList.add('border-primary', 'bg-primary', 'bg-opacity-20', 'text-primary');
                btn.classList.remove('border-gray-600', 'text-gray-300');
            }

            btn.onclick = () => {
                pickerInputNew.value = ''; 
                document.querySelectorAll('.picker-item-btn').forEach(b => {
                    b.classList.remove('border-primary', 'bg-primary', 'text-primary', 'border-expense', 'bg-expense', 'text-expense', 'bg-opacity-20');
                    b.classList.add('border-gray-600', 'text-gray-300');
                });
                
                btn.classList.add('border-primary', 'bg-primary', 'bg-opacity-20', 'text-primary');
                btn.classList.remove('border-gray-600', 'text-gray-300');
                
                // SỬA LỖI Ở ĐÂY: Nhặt thêm currency từ item trong DB bỏ vào bộ nhớ tạm
                tempSelection = { id: item.id, name: item.name, currency: item.currency || 'VND' };
            };
            
            pickerList.appendChild(btn);
        });
    }

    // Mở Popup
    async function openItemPicker(target) {
        currentPickerTarget = target;
        tempSelection = { ...appState.formState[target] }; 
        pickerInputNew.value = ''; // Xóa trắng ô nhập liệu mỗi lần mở
        
        const titles = { wallet: 'Select Wallet', walletTo: 'Select To Wallet', category: 'Select Category', tag: 'Select Tag' };
        document.getElementById('picker-title').innerText = titles[target];
        
        itemPickerModal.classList.remove('hidden');
        itemPickerModal.classList.add('flex');
        pickerList.innerHTML = '<p class="text-center w-full text-gray-400 mt-2 text-sm"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</p>';
        
        let data = [];
        if (target === 'wallet' || target === 'walletTo') data = await fetchWallets();
        else if (target === 'category') data = await fetchCategories(appState.currentTxnType);
        else if (target === 'tag') {
            if (!appState.formState.category.id) {
                pickerList.innerHTML = '<p class="text-center w-full text-expense mt-2 text-sm">Please select a Category first!</p>';
                return;
            }
            data = await fetchTags(appState.formState.category.id);
        }
        renderPickerList(data);
    }

    // Bắt sự kiện click mở Popup
    document.getElementById('btn-select-wallet').addEventListener('click', () => openItemPicker('wallet'));
    document.getElementById('btn-select-wallet-to').addEventListener('click', () => openItemPicker('walletTo'));
    document.getElementById('btn-select-category').addEventListener('click', () => openItemPicker('category'));
    document.getElementById('btn-select-tag').addEventListener('click', () => openItemPicker('tag'));

    // Nút Cancel
    document.getElementById('btn-picker-cancel').addEventListener('click', () => {
        itemPickerModal.classList.add('hidden');
        itemPickerModal.classList.remove('flex');
    });

    // LOGIC NÚT OK TÍCH HỢP KIỂM TRA TRÙNG LẶP
    document.getElementById('btn-picker-ok').addEventListener('click', () => {
        const inputText = pickerInputNew.value.trim();

        if (inputText !== '') {
            const duplicateItem = currentPickerData.find(item => item.name.toLowerCase() === inputText.toLowerCase());
            if (duplicateItem) {
                const targetBtn = document.getElementById('picker-btn-' + duplicateItem.id);
                if (targetBtn) {
                    targetBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    document.querySelectorAll('.picker-item-btn').forEach(b => {
                        b.classList.remove('border-primary', 'bg-primary', 'text-primary', 'border-expense', 'bg-expense', 'text-expense', 'bg-opacity-20');
                        b.classList.add('border-gray-600', 'text-gray-300');
                    });
                    targetBtn.classList.add('border-expense', 'bg-expense', 'bg-opacity-20', 'text-expense');
                    targetBtn.classList.remove('border-gray-600', 'text-gray-300');
                    tempSelection = { id: duplicateItem.id, name: duplicateItem.name, currency: duplicateItem.currency || 'VND' };
                    pickerInputNew.value = '';
                    return; 
                }
            } else {
                tempSelection = { id: 'NEW', name: inputText, currency: 'VND' };
            }
        }

        if (tempSelection.id || tempSelection.name) {
            appState.formState[currentPickerTarget] = { 
                id: tempSelection.id, 
                name: tempSelection.name,
                currency: tempSelection.currency || 'VND' // Lấy currency từ tempSelection
            };
            
            if (currentPickerTarget === 'category') appState.formState.tag = { id: null, name: 'Optional...' };
            
            // Tự động đổi chữ đơn vị tiền trong ô nhập liệu (UI)
            if (currentPickerTarget === 'wallet') {
                document.getElementById('currency-label').innerText = appState.formState.wallet.currency;
            } else if (currentPickerTarget === 'walletTo') {
                const labelCurrency = document.getElementById('label-transfer-currency');
                if (labelCurrency) labelCurrency.innerText = appState.formState.walletTo.currency;
            }
            
            dispatchStateEvent('updateFormDisplay');
        }
        
        itemPickerModal.classList.add('hidden');
        itemPickerModal.classList.remove('flex');
    });
}
